import cx from "classnames";
import React, { CSSProperties, useContext, useMemo } from "react";
import { EntityMenuContext } from "shared/ui/entity/entity-menu-context";
import { DotsVertical } from "shared/ui/icon";
import { Menu, MenuButton, MenuContainer } from "shared/ui/menu";
import styles from "./entity-field.module.scss";

export interface IEntityField {
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  right?: boolean;
  label?: boolean;
  flex?: boolean;
  width?: string | number;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;

  avatar?: React.ReactNode;
}

export const EntityField = (props: IEntityField) => {
  const style = useMemo(() => {
    const width = typeof props.width === "number" ? props.width + "px" : props.width;
    if (!width) {
      return props.style;
    } else {
      return {
        ...props.style,
        flex: `0 0 ${width}`,
      };
    }
  }, [props.style, props.width]);

  const menuItems = useContext(EntityMenuContext);

  return (
    <div
      className={cx(
        styles.entity_field,
        props.flex && styles.flex,
        props.right && styles.right,
        props.label && styles.label,
        props.className
      )}
      style={style}
      id={props.htmlId}
    >
      {props.avatar && <div>{props.avatar}</div>}
      <div className={cx(styles.content)} id={props.htmlId}>
        {props.title && <div className={styles.title}>{props.title}</div>}
        {props.description && <div className={styles.description}>{props.description}</div>}
        {props.children}
      </div>
      {menuItems && (
        <div className={styles.menu_button}>
          <MenuContainer placement="bottom-end">
            <MenuButton size="small" svgOnly variant="unstyled">
              <DotsVertical />
            </MenuButton>

            <Menu minWidth={150}>{menuItems}</Menu>
          </MenuContainer>
        </div>
      )}
    </div>
  );
};

EntityField.defaultProps = {};
